module.exports = __webpack_public_path__ + "static/AW_pillow-f860f8a4d1fa236d871fa14930c95c0b.jpg";